import { render, staticRenderFns } from "./POIs.vue?vue&type=template&id=2f25b06a"
import script from "./POIs.vue?vue&type=script&lang=js"
export * from "./POIs.vue?vue&type=script&lang=js"
import style0 from "./POIs.vue?vue&type=style&index=0&id=2f25b06a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports